@if (account!=null) {
  <div (click)="switchMode()" [class]="(accounts!=null)?'select':''" class="white-select">
    @if (refreshAccount) {
      <div class="account-select-overlay-container"></div>
    }
    @if (account!=null) {
      <div>
        <div>{{accountIdent(account)}}</div>
        <div class="f14">{{(account.utility!=null)?(account.utility.name+", "+((account.rateClass!=null)?account.rateClass.name:"-")):"-"}}</div>
      </div>
    }
    @if (withFilter) {
      <div [class]="(refreshAccount)?'show filter':'disable-hover'"><input type="text" (click)="filterClick($event)" [(ngModel)]="keywords" (ngModelChange)="filterAccounts()" placeholder="Filter By Name" (keydown)="filterAccounts()" /></div>
    }
    @if (accounts!=null) {
      <ul class="accountDropdown" [class]="(refreshAccount)?'show':'disable-hover'" [style]="(withFilter)?'padding-top: 30px;':''">
        <li (click)="goto('/account/add')" class="add-account-row">+ Add Account</li>
        @for (a of filteredAccounts; track a) {
          <li (click)="changeAccount(a.id)">
            <div>
              <div>{{a.name}}</div>
              <div class="f14">{{a.utilityInfo}}</div>
              <div class="f14" [class]="(a.isRate)?'':'red'">Supply Service: {{a.supplierName}} @if (a.termTo!=null) {
                <span>through {{a.termTo | date:'shortDate'}}</span>
              }</div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
}
@if (account==null && client!=null) {
  <div class="white-select">
    <div>{{client.nameAsClient}}</div>
  </div>
}
